import { createTheme as createMuiTheme, darken, lighten, ThemeOptions } from '@mui/material/styles';

import { breakpoints } from './breakpoints';
import { overrideComponents } from './overrides';
import { palette } from './palette';
import { customShadows } from './shadows';
import { shape } from './shape';
import { typography } from './typography';

const SPACING = 4;
const COEFFICIENT = 0.3;

export type ThemeMode = 'light' | 'dark';

// TODO: fix any
export const createTheme = ({ mode, primaryColor }: { mode: ThemeMode; primaryColor?: string }) => {
  const themePalette = mode === 'light' ? palette.light : palette.dark;

  const themeOptions: ThemeOptions = {
    palette: {
      ...themePalette,
      ...(primaryColor && {
        primary: {
          light: lighten(primaryColor, COEFFICIENT),
          main: primaryColor,
          dark: darken(primaryColor, COEFFICIENT),
        },
      }),
    },
    typography,
    breakpoints,
    spacing: SPACING,
    shape,
    customShadows,
  };

  const theme = createMuiTheme(themeOptions);
  (theme as any).components = overrideComponents(theme);
  return theme;
};
